export default __webpack_public_path__ + "6aad5f30e120bdd8bdc9b51f0110b0a7.png";